import { render, staticRenderFns } from "./SizeOptionGroups.vue?vue&type=template&id=37c62b44&scoped=true&"
import script from "./SizeOptionGroups.vue?vue&type=script&lang=ts&"
export * from "./SizeOptionGroups.vue?vue&type=script&lang=ts&"
import style0 from "./SizeOptionGroups.vue?vue&type=style&index=0&id=37c62b44&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c62b44",
  null
  
)

export default component.exports